import {
  holidays_2025,
  holidays_2026,
  holidays_2027,
  holidays_2028,
  holidays_2029,
  holidays_2030,
} from "@/utils/holydays.js";

const feriados = [
  ...holidays_2025,
  ...holidays_2026,
  ...holidays_2027,
  ...holidays_2028,
  ...holidays_2029,
  ...holidays_2030,
];

const MINIMO = 3; // dias habiles minimos

function esDiaDeSemana(fecha) {
  const diaSemana = fecha.getDay();
  return diaSemana >= 1 && diaSemana <= 5; // 1 lunes, 5 viernes
}

function esFeriado(fecha) {
  const fechaStr = fecha.toISOString().split("T")[0]; // formato YYYY-MM-DD
  return feriados.includes(fechaStr);
}

function esDiaHabil(fecha) {
  return esDiaDeSemana(fecha) && !esFeriado(fecha);
}

// comienza desde el dia siguiente
function calcularDiaHabil(fechaInicio, fechaFin) {
  let diaHabil = 0;
  let fechaActual = new Date(fechaInicio);
  fechaActual.setDate(fechaActual.getDate() + 1);

  while (fechaActual < fechaFin) {
    if (esDiaHabil(fechaActual)) {
      diaHabil++;
    }
    fechaActual.setDate(fechaActual.getDate() + 1);
  }

  return diaHabil;
}

// normalizados a medianoche
function validarDiaHabil(fechaObjetivo) {
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  const fechaTarget =
    typeof fechaObjetivo === "string"
      ? new Date(fechaObjetivo)
      : new Date(fechaObjetivo);
  fechaTarget.setHours(0, 0, 0, 0);

  const isDiaHabil = calcularDiaHabil(hoy, fechaTarget);
  const isValid = isDiaHabil >= MINIMO;

  let mensaje = "";
  if (!isValid) {
    const resto = MINIMO - isDiaHabil;
    mensaje =
      `La fecha de inicio de inscripciones debe definirse con al menos ${MINIMO} días hábiles de anticipación. ` +
      `Hoy solo hay ${isDiaHabil} días hábiles hasta la fecha seleccionada. ` +
      `Por favor, actualice la fecha de inicio de inscripciones de su evento. ` +
      `Aún faltan ${resto} días hábiles para cumplir el requisito.`;
  }

  return {
    isValid,
    isDiaHabil,
    MINIMO,
    mensaje,
  };
}

export {
  esDiaDeSemana,
  esFeriado,
  esDiaHabil,
  calcularDiaHabil,
  validarDiaHabil,
};
